var _defs, _rect, _circle, _text, _circle2, _text2, _rect2, _text3, _rect3, _text4, _line, _line2, _line3, _line4, _text5, _text6, _text7, _text8, _text9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ah",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#2c2416"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "aa",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#8b6f47"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "hatch",
    width: 14,
    height: 14,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 14,
    stroke: "#8b6f47",
    strokeWidth: 5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "#ece3d2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 150,
    r: 72,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 166,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 46,
    fill: "#2c2416",
    textAnchor: "middle"
  }, "T1")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 870,
    cy: 450,
    r: 72,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 466,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 46,
    fill: "#2c2416",
    textAnchor: "middle"
  }, "T2")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 84,
    width: 132,
    height: 132,
    fill: "#e0d7c8",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 166,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 46,
    fill: "#2c2416",
    textAnchor: "middle"
  }, "R1")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 384,
    width: 132,
    height: 132,
    fill: "#e0d7c8",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 466,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 46,
    fill: "#2c2416",
    textAnchor: "middle"
  }, "R2")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 406,
    y1: 150,
    x2: 798,
    y2: 150,
    stroke: "#8b6f47",
    strokeWidth: 6,
    markerEnd: "url(#aa)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 870,
    y1: 220,
    x2: 870,
    y2: 372,
    stroke: "#8b6f47",
    strokeWidth: 6,
    markerEnd: "url(#aa)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 794,
    y1: 450,
    x2: 402,
    y2: 450,
    stroke: "#8b6f47",
    strokeWidth: 6,
    markerEnd: "url(#aa)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 380,
    x2: 330,
    y2: 228,
    stroke: "#8b6f47",
    strokeWidth: 6,
    markerEnd: "url(#aa)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 126,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#6b5d4f",
    textAnchor: "middle"
  }, "waits for")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 500,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#6b5d4f",
    textAnchor: "middle"
  }, "waits for")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 900,
    y: 312,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#6b5d4f",
    textAnchor: "start"
  }, "held by")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 312,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 32,
    fill: "#6b5d4f",
    textAnchor: "end"
  }, "held by")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 314,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 44,
    fill: "#2c2416",
    textAnchor: "middle",
    fontStyle: "italic"
  }, "deadlock")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioOs);
export default __webpack_public_path__ + "static/media/portfolio-os.03b633965651053eb4aa06ad1bb4e571.svg";
export { ForwardRef as ReactComponent };